export const Storage = {
  ADMIN_TOKEN: 'admin_token',
};

export enum FeeSettingsType {
  unstakeFee = 'unstakeFee',
  interestWithdrawal = 'interestWithdrawal',
  pool = 'pool',
  off = 'staking-off',
  maximumSystemStake = 'maximumSystemStake',
  maximumStakePerUser = 'maximumStakePerUser',
  maximumInputUnstake = 'maximumInputUnstake',
}

export const Timezone = 'Asia/Tokyo';
